import GroupPeek from './peeks/GroupPeek'
import LocationPeek from './peeks/LocationPeek'
import MeterPeek from './peeks/MeterPeek'
import OrganisationPeek from './peeks/OrganisationPeek'
import OrgSummaryPeek from './peeks/OrgSummaryPeek'
import PartnerPeek from './peeks/PartnerPeek'
import UserPeek from './peeks/UserPeek'

/**
 * Every record type that can be peeked, keyed by the `type` an EntityLink
 * names. Adding a connection elsewhere in the app is: write a peek component
 * (see peeks/PeekLayout for the shared frame), register it here, and wrap the
 * reference in <EntityLink type="…" id={…}>.
 */
export const PEEK_REGISTRY = {
    location: { Peek: LocationPeek },
    'electricity-meter': { Peek: MeterPeek },
    'gas-meter': { Peek: MeterPeek },
    'water-meter': { Peek: MeterPeek },
    organisation: { Peek: OrganisationPeek },
    'org-summary': { Peek: OrgSummaryPeek },
    group: { Peek: GroupPeek },
    partner: { Peek: PartnerPeek },
    user: { Peek: UserPeek }
}
